

$(function(){
    $(document).on("change", "[name=id].original-selector", function () {
        var selected = $(this).val();
        var variant = hc_product_variants.find(z => z.id == selected);
        console.log(variant);
        var gram = variant.metafields.find(z => z.key === 'gram').value;
        var pirlanta_rengi = variant.metafields.find(z => z.key === 'pirlanta_rengi').value;
        var carat_options = variant.metafields.find(z => z.key === 'carat_options').value;
        var pirlanta_berrakligi = variant.metafields.find(z => z.key === 'pirlanta_berrakligi').value;
        var pirlanta_kesimi = variant.metafields.find(z => z.key === 'pirlanta_kesimi').value;
        var d1_ = variant.metafields.find(z => z.key === 'd1_').value;
        var d2_ = variant.metafields.find(z => z.key === 'd2_').value;
        var d3_ = variant.metafields.find(z => z.key === 'd3_').value;
        var ot1isim = variant.metafields.find(z => z.key === 'ot1isim').value;
        var ot2isim = variant.metafields.find(z => z.key === 'ot2isim').value;
        var ot1ct = variant.metafields.find(z => z.key === 'ot1ct').value;
        var ot2ct = variant.metafields.find(z => z.key === 'ot2ct').value;
        var altin_renk = variant.metafields.find(z => z.key === 'altin_renk').value;
        var altin_ayar = variant.metafields.find(z => z.key === 'altin_ayar').value;
        var totalCarat = (parseFloat(d1_)+ parseFloat(d2_) + parseFloat(d3_)).toFixed(2);
      
        $('.variant-description-table .table-d1').text(d1_);
        $('.variant-description-table .table-d2').text(d2_);
        $('.variant-description-table .table-d3').text(d3_);
        $('.variant-description-table .table-ot1').text(ot1ct);
        $('.variant-description-table .table-ot2').text(ot2ct);
      
        $('.variant-description-table tbody tr td').eq(2).text(pirlanta_rengi);
        $('.variant-description-table tbody tr td').eq(3).text(pirlanta_berrakligi);
        $('.variant-description-table tbody tr td').eq(4).text(pirlanta_kesimi);
      

        $('.title-row h1.title span').text(totalCarat + ' ct ');
        gram = parseFloat(gram).toFixed(2);
        $('.description-dynamic').text(`${totalCarat} ct | ${pirlanta_rengi} | ${pirlanta_berrakligi} | ${gram} gr | ${altin_ayar} | ${altin_renk}`);  
    });
  
  if($('li.is-unavailable').length > 0 ) {
    $('li.is-unavailable').remove();
  }
  
  if($('.input-row .size-chart-container').length > 0 ) {
    $('.input-row .size-chart-container').remove();
  }
  
    if(($('.carat-digit').length > 0) ){
      updateElement('.title-row h1.title span');
      updateElement('.description-dynamic');
      updateElement('.input-row .cc-select__btn');
      for (let i = 0; i < hc_product_variants.length; i++) {
        updateElement('.input-row .digit-' + hc_product_variants[i].id + ' span:first');
      }
   }

    if($('.description-dynamic span').length > 0 ) {
      var fixedGram = parseFloat($('.description-dynamic span').html()).toFixed(2);
      if (!isNaN(fixedGram)) {
        $('.description-dynamic span').html(fixedGram + ' gr | ');
      }
    }
  
}) 

function updateElement(selector) {
  var element = $(selector);
  var value = element.html();
  if (value) {
    var splitValue = value.split('|');
    if (!isNaN(parseFloat(splitValue[0]))) {
      splitValue[0] = parseFloat(splitValue[0]).toFixed(2) + ' ct ';
    }
    element.html(splitValue.join(' | '));
  }
}

const selectedLanguage = document.querySelector('.selected-language');
const languageOptions = document.querySelector('.language-options');

selectedLanguage.addEventListener('click', () => {
  languageOptions.classList.toggle('show');
});

const languageList = document.querySelectorAll('.language-options li');

languageList.forEach((language) => {
  language.addEventListener('click', () => {
    const lang = language.getAttribute('data-lang');
    const img = language.querySelector('img').getAttribute('src');
    const name = language.querySelector('span').textContent;
    selectedLanguage.innerHTML = `
      <img src="${img}" alt="${name}">
      <span>${name}</span>
      <i class="fa fa-angle-down"></i>
    `;
    languageOptions.classList.remove('show');
  });
});

document.addEventListener('click', (event) => {
  if (!selectedLanguage.contains(event.target) && !languageOptions.contains(event.target)) {
    languageOptions.classList.remove('show');
  }
});

// Wait for cart to update
document.addEventListener("cart.updated", function(event) {
  // Get cart subtotal
  var subtotal = event.detail.items_subtotal_price;
  
  // Check if subtotal is over 400
  if (subtotal >= 400) {
    // Check if '8180966359333' product is already in cart
    var inCart = false;
    for (var i = 0; i < event.detail.items.length; i++) {
      if (event.detail.items[i].product_id == '8180966359333') {
        inCart = true;
        break;
      }
    }
    
    // Add '8180966359333' product if it's not already in cart and product is not tagged with 'disc5' or 'disc15'
    if (!inCart && event.detail.items.every(item => !item.product_tag.includes('disc5') && !item.product_tag.includes('disc15'))) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          quantity: 1,
          id: '8180966359333'
        })
      })
      .then(function(response) {
        window.location.reload();
      });
    }
  }
//CARAT OPTIONS
class CaratRangeInstance {
    constructor(container) {
      this.container = container;
      this.selectors = {
        inputMin: '.cc-carat-range__input--min',
        inputMax: '.cc-carat-range__input--max',
        control: '.cc-carat-range__control',
        controlMin: '.cc-carat-range__control--min',
        controlMax: '.cc-carat-range__control--max',
        bar: '.cc-carat-range__bar',
        activeBar: '.cc-carat-range__bar-active' };

      this.controls = {
        min: {
          barControl: container.querySelector(this.selectors.controlMin),
          input: container.querySelector(this.selectors.inputMin) },

        max: {
          barControl: container.querySelector(this.selectors.controlMax),
          input: container.querySelector(this.selectors.inputMax) } };


      this.controls.min.value = parseInt(this.controls.min.input.value === '' ? this.controls.min.input.placeholder : this.controls.min.input.value);
      this.controls.max.value = parseInt(this.controls.max.input.value === '' ? this.controls.max.input.placeholder : this.controls.max.input.value);
      this.valueMin = this.controls.min.input.min;
      this.valueMax = this.controls.min.input.max;
      this.valueRange = this.valueMax - this.valueMin;

      [this.controls.min, this.controls.max].forEach(item => {
        item.barControl.setAttribute('aria-valuemin', this.valueMin);
        item.barControl.setAttribute('aria-valuemax', this.valueMax);
        item.barControl.setAttribute('tabindex', 0);
      });
      this.controls.min.barControl.setAttribute('aria-valuenow', this.controls.min.value);
      this.controls.max.barControl.setAttribute('aria-valuenow', this.controls.max.value);

      this.bar = container.querySelector(this.selectors.bar);
      this.activeBar = container.querySelector(this.selectors.activeBar);
      this.inDrag = false;
      this.rtl = document.querySelector('html[dir=rtl]');

      this.bindEvents();
      this.render();
    }

    getPxToValueRatio() {
      var r = this.bar.clientWidth / (this.valueMax - this.valueMin);
      if (this.rtl) {
        return -r;
      } else {
        return r;
      }
    }

    getPcToValueRatio() {
      return 100.0 / (this.valueMax - this.valueMin);
    }

    setActiveControlValue(value) {
      // only accept valid numbers
      if (isNaN(parseInt(value))) return;

      // clamp & default
      if (this.activeControl === this.controls.min) {
        if (value === '') {
          value = this.valueMin;
        }
        value = Math.max(this.valueMin, value);
        value = Math.min(value, this.controls.max.value);
      } else {
        if (value === '') {
          value = this.valueMax;
        }
        value = Math.min(this.valueMax, value);
        value = Math.max(value, this.controls.min.value);
      }

      // round
      this.activeControl.value = Math.round(value);

      // update input
      if (this.activeControl.input.value != this.activeControl.value) {
        if (this.activeControl.value == this.activeControl.input.placeholder) {
          this.activeControl.input.value = '';
        } else {
          this.activeControl.input.value = this.activeControl.value;
        }
        this.activeControl.input.dispatchEvent(new CustomEvent('change', { bubbles: true, cancelable: false, detail: { sender: 'theme:component:carat_range' } }));
      }

      // a11y
      this.activeControl.barControl.setAttribute('aria-valuenow', this.activeControl.value);
    }

    render() {
      this.drawControl(this.controls.min);
      this.drawControl(this.controls.max);
      this.drawActiveBar();
    }

    drawControl(control) {
      var x = (control.value - this.valueMin) * this.getPcToValueRatio() + '%';
      if (this.rtl) {
        control.barControl.style.right = x;
      } else {
        control.barControl.style.left = x;
      }
    }

    drawActiveBar() {
      var s = (this.controls.min.value - this.valueMin) * this.getPcToValueRatio() + '%',
      e = (this.valueMax - this.controls.max.value) * this.getPcToValueRatio() + '%';
      if (this.rtl) {
        this.activeBar.style.left = e;
        this.activeBar.style.right = s;
      } else {
        this.activeBar.style.left = s;
        this.activeBar.style.right = e;
      }
    }

    handleControlTouchStart(e) {
      e.preventDefault();
      this.startDrag(e.target, e.touches[0].clientX);
      this.boundControlTouchMoveEvent = this.handleControlTouchMove.bind(this);
      this.boundControlTouchEndEvent = this.handleControlTouchEnd.bind(this);
      window.addEventListener('touchmove', this.boundControlTouchMoveEvent);
      window.addEventListener('touchend', this.boundControlTouchEndEvent);
    }

    handleControlTouchMove(e) {
      this.moveDrag(e.touches[0].clientX);
    }

    handleControlTouchEnd(e) {
      e.preventDefault();
      window.removeEventListener('touchmove', this.boundControlTouchMoveEvent);
      window.removeEventListener('touchend', this.boundControlTouchEndEvent);
      this.stopDrag();
    }

    handleControlMouseDown(e) {
      e.preventDefault();
      this.startDrag(e.target, e.clientX);
      this.boundControlMouseMoveEvent = this.handleControlMouseMove.bind(this);
      this.boundControlMouseUpEvent = this.handleControlMouseUp.bind(this);
      window.addEventListener('mousemove', this.boundControlMouseMoveEvent);
      window.addEventListener('mouseup', this.boundControlMouseUpEvent);
    }

    handleControlMouseMove(e) {
      this.moveDrag(e.clientX);
    }

    handleControlMouseUp(e) {
      e.preventDefault();
      window.removeEventListener('mousemove', this.boundControlMouseMoveEvent);
      window.removeEventListener('mouseup', this.boundControlMouseUpEvent);
      this.stopDrag();
    }

    startDrag(target, startX) {
      if (this.controls.min.barControl === target) {
        this.activeControl = this.controls.min;
      } else {
        this.activeControl = this.controls.max;
      }
      this.dragStartX = startX;
      this.dragStartValue = this.activeControl.value;
      this.inDrag = true;
    }

    moveDrag(moveX) {
      if (this.inDrag) {
        var value = this.dragStartValue + (moveX - this.dragStartX) / this.getPxToValueRatio();
        this.setActiveControlValue(value);
        this.render();
      }
    }

    stopDrag() {
      this.inDrag = false;
    }

    handleControlKeyDown(e) {
      if (e.key === 'ArrowRight') {
        this.incrementControlFromKeypress(e.target, 10.0);
      } else if (e.key === 'ArrowLeft') {
        this.incrementControlFromKeypress(e.target, -10.0);
      }
    }

    incrementControlFromKeypress(control, pxAmount) {
      if (this.controls.min.barControl === control) {
        this.activeControl = this.controls.min;
      } else {
        this.activeControl = this.controls.max;
      }
      this.setActiveControlValue(this.activeControl.value + pxAmount / this.getPxToValueRatio());
      this.render();
    }

    handleInputChange(e) {
      // strip out non numeric values
      e.target.value = e.target.value.replace(/\D/g, '');

      if (!e.detail || e.detail.sender != 'theme:component:carat_range') {
        if (this.controls.min.input === e.target) {
          this.activeControl = this.controls.min;
        } else {
          this.activeControl = this.controls.max;
        }
        this.setActiveControlValue(e.target.value);
        this.render();
      }
    }

    handleInputKeyup(e) {
      // enforce numeric chars in the input
      setTimeout(function () {
        this.value = this.value.replace(/\D/g, '');
      }.bind(e.target), 10);
    }

    bindEvents() {
      [this.controls.min, this.controls.max].forEach(item => {
        item.barControl.addEventListener('touchstart', this.handleControlTouchStart.bind(this));
        item.barControl.addEventListener('mousedown', this.handleControlMouseDown.bind(this));
        item.barControl.addEventListener('keydown', this.handleControlKeyDown.bind(this));
        item.input.addEventListener('change', this.handleInputChange.bind(this));
        item.input.addEventListener('keyup', this.handleInputKeyup.bind(this));
      });
    }

    destroy() {
    }}
  class CaratRange extends ccComponent {
    constructor() {var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'carat-range';var cssSelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ".cc-".concat(name);
      super(name, cssSelector);
    }

    init(container) {
      super.init(container);
      this.registerInstance(container, new CaratRangeInstance(container));
    }

    destroy(container) {
      this.destroyInstance(container);
      super.destroy(container);
    }}


  new CaratRange();
  
});

